import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import * as XLSX from "xlsx";

function ListadoArticulos() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS || (process.env.REACT_APP_URL_AREAS || "").replace("areas", "empresas");
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [SKU, setSKU] = useState("");
  const [costoMX, setCostoMX] = useState(0);
  const [venta, setVenta] = useState(0);
  const [precioMayoreo, setPrecioMayoreo] = useState(0);
  const [largoProducto, setLargoProducto] = useState(0);
  const [anchoProducto, setAnchoProducto] = useState(0);
  const [altoProducto, setAltoProducto] = useState(0);
  const [pesoProducto, setPesoProducto] = useState(0);
  const [largoMaster, setLargoMaster] = useState(0);
  const [anchoMaster, setAnchoMaster] = useState(0);
  const [altoMaster, setAltoMaster] = useState(0);
  const [pesoMaster, setPesoMaster] = useState(0);


  const [lineas, setLineas] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [proveedores, setProveedores] = useState([]);

  const [selectedCodigo, setSelectedCodigo] = useState(0);
  const [selectedNombre, setSelectedNombre] = useState(0);
  const [selectedLinea, setSelectedLinea] = useState(0);
  const [selectedEmpresa, setSelectedEmpresa] = useState(0);
  const [selectedProveedor, setSelectedProveedor] = useState(0);
  const [selectedActivo, setSelectedActivo] = useState("Si");

  const [selectedLineaEdit, setSelectedLineaEdit] = useState("");
  const [selectedEmpresaEdit, setSelectedEmpresaEdit] = useState("");
  const [selectedProveedorEdit, setSelectedProveedorEdit] = useState("");
  const [idEditArticulo, setIdEditArticulo] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;

  const [fichaArchivo, setFichaArchivo] = useState();
  const [fichaURL, setFichaURL] = useState("");
  const [modalFichaTecnica, setModalFichaTecnica] = useState(false);
  const toggleFichaTecnica = () => setModalFichaTecnica(!modalFichaTecnica);
  const URL_FICHA_POST = process.env.REACT_APP_URL_UPFICHA;

  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);

  // Actualizacion masiva de Costo MX desde Excel
  const [modalCostos, setModalCostos] = useState(false);
  const toggleCostos = () => setModalCostos(!modalCostos);
  const [filasCostos, setFilasCostos] = useState([]);
  const [filasIgnoradas, setFilasIgnoradas] = useState(0);
  const [leyendoArchivo, setLeyendoArchivo] = useState(false);
  const [procesandoCostos, setProcesandoCostos] = useState(false);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        // Array para pagination
        let arrayTabla = allArticulos
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              activo: a.is_active,
              codigo: a.codigo ?? "",
              nombre: a.nombre ?? "",
              SKU: a.SKU ?? "",
              costoMX: a.costoMX ?? 0,
              venta: a.venta ?? 0,
              precioMayoreo: a.precioMayoreo ?? 0,
              largoProducto: a.largoProducto ?? 0,
              anchoProducto: a.anchoProducto ?? 0,
              altoProducto: a.altoProducto ?? 0,
              pesoProducto: a.pesoProducto ?? 0,
              largoMaster: a.largoMaster ?? 0,
              anchoMaster: a.anchoMaster ?? 0,
              altoMaster: a.altoMaster ?? 0,
              pesoMaster: a.pesoMaster ?? 0,

              linea: a.lineas?.[0]?.name ?? "",
              empresa: a.empresas?.[0]?.name ?? "",
              proveedor: a.proveedores?.[0]?.nombre_comercial ?? "",
              idLinea: a.lineas?.[0]?._id ?? "",
              idEmpresa: a.empresas?.[0]?._id ?? "",
              idProveedor: a.proveedores?.[0]?._id ?? "",
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setComments(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setLineas(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setEmpresas(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${URL_PROVEEDORES}Tipo/China`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setProveedores(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const ListaArticulos = comments.sort((a, b) =>
    a.nombre > b.nombre ? 1 : -1
  );

  const moneda = (n) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(n || 0);

  function articulosFiltrados() {
    return ListaArticulos.filter(
      (a) =>
        (selectedLinea == 0 || selectedLinea == a.idLinea) &&
        (selectedEmpresa == 0 || selectedEmpresa == a.idEmpresa) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
    );
  }

  function generaPDF() {
    const dataPDF = articulosFiltrados().map((a) => [
      a.codigo,
      a.SKU,
      a.nombre,
      a.linea,
      a.empresa,
      a.proveedor,
      moneda(a.costoMX),
      moneda(a.venta),
      moneda(a.precioMayoreo),
    ]);
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 30, 30);
    doc.text(`Listado Articulos`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "SKU",
          "Nombre",
          "Linea",
          "Empresa",
          "Proveedor",
          "Costo MX",
          "Precio",
          "Mayoreo",
        ],
      ],
      body: dataPDF,
      startY: 45,
    });
    return doc;
  }

  function PDFTabla() {
    generaPDF().save(`Articulos.pdf`);
  }

  function excel() {
    const dataExcel = articulosFiltrados().map((a) => ({
      Id: a._id,
      Codigo: a.codigo,
      SKU: a.SKU,
      Nombre: a.nombre,
      Linea: a.linea,
      Empresa: a.empresa,
      Proveedor: a.proveedor,
      CostoMX: a.costoMX,
      Precio: a.venta,
      PrecioMayoreo: a.precioMayoreo,
    }));

    const columnas = [
      "Id",
      "Codigo",
      "SKU",
      "Nombre",
      "Linea",
      "Empresa",
      "Proveedor",
      "CostoMX",
      "Precio",
      "PrecioMayoreo",
    ];

    const option = {
      fileName: "ListadoArticulos",
      datas: [
        {
          sheetData: dataExcel,
          sheetName: "ListadoArticulos",
          sheetFilter: columnas,
          sheetHeader: columnas,
        },
      ],
    };

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  // Lee el Excel de Costo MX. Acepta el mismo archivo que genera el boton Excel:
  // identifica el articulo por Id y, si no viene, por SKU o Codigo.
  function importarArchivoCostos(event) {
    const target = event.target;
    if (!target.files || !target.files[0]) return;
    setLeyendoArchivo(true);
    setFilasCostos([]);
    setFilasIgnoradas(0);

    const reader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);
    reader.onloadend = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const hoja = workbook.Sheets[workbook.SheetNames[0]];
        const renglones = XLSX.utils.sheet_to_json(hoja);

        // Indices para poder identificar el articulo por SKU o Codigo
        const porSKU = {};
        const porCodigo = {};
        comments.forEach((c) => {
          if (c.SKU) porSKU[String(c.SKU).trim().toUpperCase()] = c._id;
          if (c.codigo) porCodigo[String(c.codigo).trim().toUpperCase()] = c._id;
        });
        const idsValidos = new Set(comments.map((c) => c._id));

        const validas = [];
        let ignoradas = 0;

        renglones.forEach((r) => {
          const idArchivo = String(r.Id ?? r.id ?? r._id ?? "").trim();
          const sku = String(r.SKU ?? r.sku ?? "").trim().toUpperCase();
          const cod = String(r.Codigo ?? r.codigo ?? "").trim().toUpperCase();

          const id = idsValidos.has(idArchivo)
            ? idArchivo
            : porSKU[sku] || porCodigo[cod];

          const costo = parseFloat(
            r.CostoMX ?? r.costoMX ?? r["Costo MX"] ?? r.CostoMx
          );
          const precio = parseFloat(r.Precio ?? r.precio ?? r.Venta ?? r.venta);
          const mayoreo = parseFloat(
            r.PrecioMayoreo ?? r.precioMayoreo ?? r.Mayoreo ?? r.mayoreo
          );

          // Cada columna se toma por separado: la que venga vacia no se toca
          const cambios = {};
          if (!isNaN(costo)) cambios.costoMX = costo;
          if (!isNaN(precio)) {
            cambios.venta = precio;
            cambios.lista1 = precio;
            cambios.lista3 = precio;
            cambios.lista4 = precio;
            cambios.lista1Bruto = precio;
            cambios.lista3Bruto = precio;
            cambios.lista4Bruto = precio;
          }
          if (!isNaN(mayoreo)) {
            cambios.precioMayoreo = mayoreo;
            cambios.lista2 = mayoreo;
            cambios.lista2Bruto = mayoreo;
          }

          // Solo se actualiza si se identifico el articulo y trae algo que cambiar
          if (id && Object.keys(cambios).length) {
            validas.push({ articulos: id, cambios });
          } else {
            ignoradas++;
          }
        });

        setFilasCostos(validas);
        setFilasIgnoradas(ignoradas);
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo leer el archivo",
        });
      }
      setLeyendoArchivo(false);
    };
  }

  async function actualizaCostos() {
    if (!filasCostos.length) return;
    setProcesandoCostos(true);

    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    let actualizados = 0;
    let fallidos = 0;
    const LOTE = 20;

    for (let i = 0; i < filasCostos.length; i += LOTE) {
      const lote = filasCostos.slice(i, i + LOTE);
      const resultados = await Promise.allSettled(
        lote.map((a) =>
          axios.patch(`${URL_ARTICULOS}/${a.articulos}`, a.cambios, { headers })
        )
      );
      resultados.forEach((r) =>
        r.status === "fulfilled" ? actualizados++ : fallidos++
      );
    }

    await axios
      .post(
        URL_LOGS,
        {
          tipo: "Editar Costos y Precios",
          detalle: `Costos y precios masivos: ${actualizados} articulos`,
          user: user.id,
        },
        { headers }
      )
      .catch((err) => console.log(err));

    setProcesandoCostos(false);
    Swal.fire(
      fallidos ? "Terminado con errores" : "Good job!",
      `${actualizados} articulos actualizados${
        fallidos ? ` / ${fallidos} con error` : ""
      }`,
      fallidos ? "warning" : "success"
    );
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  }

  function enviaMail() {
    var att = generaPDF().output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Articulos",
          email: mailTo,
          fileName: "ListadoArticulos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Articulos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaFoto(idEdit) {
    setPhoto("");
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${idEdit}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        if (data.data.version) {
          setPhoto(data.data.version);
        }
      })
      .catch((err) => console.log(err));

    setIdEditArticulo(idEdit);
    toggleFoto();
  }

  function jalaFichaTecnica(idEdit) {
    setFichaURL("");
    const URL_GET_FICHA = `${process.env.REACT_APP_URL_GETMEDIA}Ficha/${idEdit}`;

    axios
      .get(URL_GET_FICHA, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        const url = res.data?.secure_url || res.data?.url || "";
        if (url) setFichaURL(url);
      })
      .catch((err) => console.log(err));

    setIdEditArticulo(idEdit);
    toggleFichaTecnica();
  }

  function jalaInfo(
    codigo,
    nombre,
    SKU,
    costoMX,
    venta,
    precioMayoreo,
    medidas,
    idLinea,
    idEmpresa,
    idProveedor,
    idEdit
  ) {
    setCodigo(codigo);
    setNombre(nombre);
    setSKU(SKU);
    setCostoMX(costoMX);
    setVenta(venta);
    setPrecioMayoreo(precioMayoreo);
    setLargoProducto(medidas.largoProducto ?? 0);
    setAnchoProducto(medidas.anchoProducto ?? 0);
    setAltoProducto(medidas.altoProducto ?? 0);
    setPesoProducto(medidas.pesoProducto ?? 0);
    setLargoMaster(medidas.largoMaster ?? 0);
    setAnchoMaster(medidas.anchoMaster ?? 0);
    setAltoMaster(medidas.altoMaster ?? 0);
    setPesoMaster(medidas.pesoMaster ?? 0);

    setSelectedLineaEdit(idLinea);
    setSelectedEmpresaEdit(idEmpresa);
    setSelectedProveedorEdit(idProveedor);
    setIdEditArticulo(idEdit);
    toggleEdit();
  }

  function editArticulos(event) {
    event.preventDefault();

    const URL_ARTICULOS_EDIT = `${process.env.REACT_APP_URL_ARTICULOS}/${idEditArticulo}`;

    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    // El precio de venta capturado alimenta las 4 listas de precios que usa Ventas.
    const precio = parseFloat(venta) || 0;
    const mayoreo = parseFloat(precioMayoreo) || 0;

    axios
      .patch(
        URL_ARTICULOS_EDIT,
        {
          codigo,
          nombre,
          SKU: SKU ? SKU.toUpperCase() : SKU,
          costoMX: parseFloat(costoMX) || 0,
          venta: precio,
          precioMayoreo: mayoreo,
          // Lista 1 = precio normal, Lista 2 = mayoreo
          lista1: precio,
          lista2: mayoreo,
          lista3: precio,
          lista4: precio,
          lista1Bruto: precio,
          lista2Bruto: mayoreo,
          lista3Bruto: precio,
          lista4Bruto: precio,
          largoProducto: parseFloat(largoProducto) || 0,
          anchoProducto: parseFloat(anchoProducto) || 0,
          altoProducto: parseFloat(altoProducto) || 0,
          pesoProducto: parseFloat(pesoProducto) || 0,
          largoMaster: parseFloat(largoMaster) || 0,
          anchoMaster: parseFloat(anchoMaster) || 0,
          altoMaster: parseFloat(altoMaster) || 0,
          pesoMaster: parseFloat(pesoMaster) || 0,

          lineas: selectedLineaEdit,
          ...(selectedEmpresaEdit ? { empresas: selectedEmpresaEdit } : {}),
          proveedores: selectedProveedorEdit,
        },
        { headers }
      )
      .then(async () => {
        // 2) Subidas opcionales (foto y/o ficha)
        const uploads = [];

        // --- Foto ---
        if (file) {
          const fdFoto = new FormData();
          fdFoto.append("file", file);
          fdFoto.append("articulo", idEditArticulo);

          uploads.push(axios.post(URL_FILEPOST, fdFoto, { headers }));
        }

        // --- Ficha técnica PDF ---
        if (fichaArchivo) {
          const fdFicha = new FormData();
          fdFicha.append("file", fichaArchivo);
          fdFicha.append("articulo", idEditArticulo);

          uploads.push(axios.post(URL_FICHA_POST, fdFicha, { headers }));
        }

        if (uploads.length) await Promise.all(uploads);

        // 3) Log
        await axios.post(
          URL_LOGS,
          {
            tipo: "Editar Articulo",
            detalle: `${nombre} ${codigo}`,
            user: user.id,
          },
          { headers }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error?.response?.data || ""}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Activo", field: "activo", sortable: true },
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "SKU", field: "SKU", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Linea", field: "linea", sortable: true },
    { name: "Empresa", field: "empresa", sortable: true },
    { name: "Proveedor", field: "proveedor", sortable: true },
    { name: "Costo MX", field: "costoMX", sortable: true },
    { name: "Precio", field: "venta", sortable: true },
    { name: "Mayoreo", field: "precioMayoreo", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const camposNumericos = ["costoMX", "venta", "precioMayoreo"];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      const searchLower = search.toLowerCase();
      computedComments = computedComments.filter(
        (comment) =>
          String(comment._id).toLowerCase().includes(searchLower) ||
          String(comment.codigo).toLowerCase().includes(searchLower) ||
          String(comment.SKU).toLowerCase().includes(searchLower) ||
          String(comment.nombre).toLowerCase().includes(searchLower) ||
          String(comment.linea).toLowerCase().includes(searchLower) ||
          String(comment.empresa).toLowerCase().includes(searchLower) ||
          String(comment.proveedor).toLowerCase().includes(searchLower)
      );
    }
    if (selectedCodigo) {
      computedComments = computedComments.filter((e) =>
        e._id.includes(selectedCodigo)
      );
    }
    if (selectedNombre) {
      computedComments = computedComments.filter((e) =>
        e._id.includes(selectedNombre)
      );
    }
    if (selectedLinea) {
      computedComments = computedComments.filter((e) =>
        e.idLinea.includes(selectedLinea)
      );
    }
    if (selectedEmpresa) {
      computedComments = computedComments.filter((e) =>
        e.idEmpresa.includes(selectedEmpresa)
      );
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedor.includes(selectedProveedor)
      );
    }
    if (selectedActivo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(selectedActivo)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field && !camposNumericos.includes(sorting.field)) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) =>
          reversed * String(a[sorting.field]).localeCompare(String(b[sorting.field]))
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      camposNumericos.includes(sorting.field)
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      camposNumericos.includes(sorting.field)
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCodigo,
    selectedNombre,
    selectedLinea,
    selectedEmpresa,
    selectedProveedor,
    selectedActivo,
  ]);

  function QRGen(idArt, SKU, nombre) {
    const doc = new jsPDF("landscape", "mm", [55, 40]);

    let codigoQR = idArt;
    var base64 = qrcode.toDataURL(codigoQR);
    var img3 = new Image();
    img3.src = base64;
    doc.addImage(img3, "png", 13, 14, 25, 25);
    doc.setFontSize(8);
    doc.text(`ID: ${idArt}`, 3, 4);
    doc.text(`SKU: ${SKU}`, 3, 7.5);

    // Función para dividir el texto en dos líneas si es necesario
    function splitTextIntoLines(text, maxLength) {
      if (text.length <= maxLength) {
        return [text]; // No es necesario dividir
      }
      const firstLine = text.slice(0, maxLength);
      const secondLine = text.slice(maxLength);
      return [firstLine, secondLine];
    }

    // Tamaño máximo de caracteres por línea
    const maxLineLength = 40;

    // Divide el nombre en líneas si es necesario
    const nombreLines = splitTextIntoLines(nombre, maxLineLength);

    doc.text(nombreLines[0], 3, 11);
    if (nombreLines[1]) {
      doc.text(nombreLines[1], 3, 14.5);
    }

    doc.save(`QR.pdf`);
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.articulos_create ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/ArticulosCreate"
                >
                  Nuevo Articulo
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Articulo
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuArticulos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button size="sm" className="btn" color="primary" onClick={excel}>
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                {user.articulos_create ? (
                  <Button
                    size="sm"
                    className="btn"
                    color="warning"
                    onClick={toggleCostos}
                  >
                    Act. Costos
                  </Button>
                ) : undefined}
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Articulos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Articulos</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedActivo}
                  onChange={(e) => {
                    setSelectedActivo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCodigo}
                  onChange={(e) => {
                    setSelectedCodigo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {comments
                    .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.codigo}</option>;
                    })}
                </Input>
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedNombre}
                  onChange={(e) => {
                    setSelectedNombre(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {comments
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.nombre}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedLinea}
                  onChange={(e) => {
                    setSelectedLinea(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {lineas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedEmpresa}
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedProveedor}
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1,
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.codigo} - {a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                return (
                  <tr>
                    <td>{a.activo}</td>
                    <td>{a.codigo}</td>
                    <td>{a.SKU}</td>
                    <td>{a.nombre}</td>
                    <td>{a.linea} </td>
                    <td>{a.empresa} </td>
                    <td>{a.proveedor} </td>
                    <td>{moneda(a.costoMX)}</td>
                    <td>{moneda(a.venta)}</td>
                    <td>{moneda(a.precioMayoreo)}</td>
                    <td>
                      {user.articulos_create ? (
                        <div>
                          <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) => jalaFoto(a._id)}
                          >
                            <i class="fas fa-camera"></i>
                          </Button>
                          <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) => jalaFichaTecnica(a._id)}
                          >
                            <i class="fas fa-file-alt"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="success"
                            onClick={(e) => QRGen(a._id, a.SKU, a.nombre)}
                          >
                            <i class="fas fa-qrcode"></i>
                          </Button>

                          <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) =>
                              jalaInfo(
                                a.codigo,
                                a.nombre,
                                a.SKU,
                                a.costoMX,
                                a.venta,
                                a.precioMayoreo,
                                {
                                  largoProducto: a.largoProducto,
                                  anchoProducto: a.anchoProducto,
                                  altoProducto: a.altoProducto,
                                  pesoProducto: a.pesoProducto,
                                  largoMaster: a.largoMaster,
                                  anchoMaster: a.anchoMaster,
                                  altoMaster: a.altoMaster,
                                  pesoMaster: a.pesoMaster,
                                },
                                a.idLinea,
                                a.idEmpresa,
                                a.idProveedor,
                                a._id,
                              )
                            }
                          >
                            <i class="far fa-edit"></i>
                          </Button>
                          <Baja
                            idStatus={a._id}
                            is_active={a.activo}
                            URL_BAJA={process.env.REACT_APP_URL_ARTICULOS}
                          />
                        </div>
                      ) : (
                        <div>
                          <Button color="info" id="Editar" size="sm" disabled>
                            <i class="far fa-edit"></i>
                          </Button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="sm" isOpen={modalFoto} toggle={toggleFoto}>
        <ModalHeader toggle={toggleFoto}>
          <h4>Foto</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {photo ? (
              <h6 style={{ textAlign: "center" }}>
                <img
                  src={`${process.env.REACT_APP_URL_FOTO_CLOUDINARY}/image/upload/v${photo}/vionettiArticulos/${idEditArticulo}.jpg`}
                  alt=""
                />
              </h6>
            ) : (
              <h4>No se ha subido una Foto....</h4>
            )}
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalFichaTecnica} toggle={toggleFichaTecnica}>
        <ModalHeader toggle={toggleFichaTecnica}>
          <h4>Ficha Tecnica</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {fichaURL ? (
              <>
                <iframe
                  title="Ficha Técnica"
                  src={fichaURL}
                  style={{ width: "100%", height: "70vh", border: 0 }}
                />
                <div className="mt-2 text-center">
                  <a href={fichaURL} target="_blank" rel="noreferrer">
                    Abrir en otra pestaña
                  </a>
                </div>
              </>
            ) : (
              <h4>No se ha subido ficha técnica...</h4>
            )}
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            Editar Articulo {codigo} / {nombre}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, margin: "18px 0 10px", color: "#1e3a8a", fontWeight: 700, fontSize: "0.9rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                DATOS GENERALES
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Modelo</Label>
              <Input
                type="text"
                placeholder="Codigo"
                value={codigo}
                required
                onChange={(e) => {
                  setCodigo(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Nombre</Label>
              <Input
                type="text"
                placeholder="Nombre"
                value={nombre}
                required
                onChange={(e) => {
                  setNombre(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>SKU</Label>
              <Input
                type="text"
                placeholder="SKU"
                value={SKU}
                required
                onChange={(e) => {
                  setSKU(e.target.value.toUpperCase());
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label>Foto</Label>
              <Input
                type="file"
                onChange={(e) => {
                  setFile(e.target.files[0]);
                }}
              />
            </Col>
            <Col md={6}>
              <Label>Ficha Tecnica</Label>
              <Input
                type="file"
                onChange={(e) => {
                  setFichaArchivo(e.target.files[0]);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, margin: "18px 0 10px", color: "#1e3a8a", fontWeight: 700, fontSize: "0.9rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                CLASIFICACIÓN
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label className="mr-sm-2">Linea</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedLineaEdit}
                required
                onChange={(e) => {
                  setSelectedLineaEdit(e.target.value);
                }}
              >
                <option value="">Selecciona una Linea</option>
                {lineas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            <Col md={4}>
              <Label className="mr-sm-2">Empresa</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedEmpresaEdit}
                required
                onChange={(e) => {
                  setSelectedEmpresaEdit(e.target.value);
                }}
              >
                <option value="">Selecciona una Empresa</option>
                {empresas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            <Col md={4}>
              <Label className="mr-sm-2">Proveedor</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedProveedorEdit}
                required
                onChange={(e) => {
                  setSelectedProveedorEdit(e.target.value);
                }}
              >
                <option value="">Selecciona un Proveedor</option>
                {proveedores
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1,
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.codigo} - {a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, margin: "18px 0 10px", color: "#1e3a8a", fontWeight: 700, fontSize: "0.9rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                COSTO Y PRECIO
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Costo MX</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Costo MX"
                value={costoMX}
                required
                onChange={(e) => {
                  setCostoMX(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Precio</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Precio"
                value={venta}
                required
                onChange={(e) => {
                  setVenta(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Precio Mayoreo</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Precio Mayoreo"
                value={precioMayoreo}
                onChange={(e) => {
                  setPrecioMayoreo(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, margin: "18px 0 10px", color: "#1e3a8a", fontWeight: 700, fontSize: "0.9rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                MEDIDAS PRODUCTO
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>Largo</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Largo"
                value={largoProducto}
                onChange={(e) => {
                  setLargoProducto(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Ancho</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Ancho"
                value={anchoProducto}
                onChange={(e) => {
                  setAnchoProducto(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Alto</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Alto"
                value={altoProducto}
                onChange={(e) => {
                  setAltoProducto(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Peso</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Peso"
                value={pesoProducto}
                onChange={(e) => {
                  setPesoProducto(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, margin: "18px 0 10px", color: "#1e3a8a", fontWeight: 700, fontSize: "0.9rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                MEDIDAS CAJA
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>Largo</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Largo"
                value={largoMaster}
                onChange={(e) => {
                  setLargoMaster(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Ancho</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Ancho"
                value={anchoMaster}
                onChange={(e) => {
                  setAnchoMaster(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Alto</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Alto"
                value={altoMaster}
                onChange={(e) => {
                  setAltoMaster(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Peso</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Peso"
                value={pesoMaster}
                onChange={(e) => {
                  setPesoMaster(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editArticulos}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="md" isOpen={modalCostos} toggle={toggleCostos}>
        <ModalHeader toggle={toggleCostos}>
          <h4>Actualizar Costos y Precios</h4>
        </ModalHeader>
        <ModalBody>
          <p style={{ fontSize: "0.85rem", color: "#64748b" }}>
            Sube el mismo Excel que descargas con el boton{" "}
            <strong>Excel</strong>, con las columnas <strong>CostoMX</strong>,{" "}
            <strong>Precio</strong> y/o <strong>PrecioMayoreo</strong> ya
            modificadas. El articulo se identifica por la columna{" "}
            <strong>Id</strong> y, si no viene, por <strong>SKU</strong> o{" "}
            <strong>Modelo</strong>. La columna que dejes vacia no se toca; los
            demas datos del articulo tampoco.
          </p>
          <Col>
            <Input
              type="file"
              name="file"
              id="file"
              accept=".xlsx,.xls,.csv"
              onChange={(event) => importarArchivoCostos(event)}
            />
          </Col>
          <br />
          {leyendoArchivo ? (
            <h6>
              <i
                className="fas fa-hourglass-half custom-spin"
                style={{ marginRight: "10px" }}
              ></i>
              Leyendo archivo...
            </h6>
          ) : undefined}
          {!leyendoArchivo && filasCostos.length ? (
            <h6>
              Se actualizaran <strong>{filasCostos.length}</strong> articulos
              {filasIgnoradas
                ? ` / ${filasIgnoradas} renglones ignorados (sin articulo o sin costo valido)`
                : ""}
            </h6>
          ) : undefined}
          {!leyendoArchivo && !filasCostos.length && filasIgnoradas ? (
            <h6 style={{ color: "#dc2626" }}>
              No se identifico ningun articulo con costo valido en el archivo.
            </h6>
          ) : undefined}
        </ModalBody>
        <ModalFooter>
          {procesandoCostos ? (
            <Button size="sm" color="success" disabled>
              <i
                className="fas fa-hourglass-half custom-spin"
                style={{ marginRight: "10px" }}
              ></i>
              Actualizando
            </Button>
          ) : (
            <Button
              size="sm"
              color="success"
              disabled={!filasCostos.length}
              onClick={actualizaCostos}
            >
              Guardar
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoArticulos;
